import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { InstitucionConSedeSeleccion, InstitucionSnp, ISedeSnp, SedeSnp } from '@/shared/model/snp/instituciones-snp.model';

@Component
export default class InstitucionesRegistrarF1Snp extends Vue {
  @Prop({ required: true })
  public solucion!: Solucion;

  @Prop({ required: true })
  public solicitud!: Solicitud;

  public institucionSeleccionada = new InstitucionSnp();
  public sedeSeleccionada: ISedeSnp = {};

  public modalVisible = false;

  public seleccionarInstitucion(seleccion: InstitucionSnp): void {
    this.institucionSeleccionada = InstitucionSnp.fromObject(seleccion);
    this.sedeSeleccionada = (this.institucionSeleccionada?.sedes ?? []).at(0) ?? {};

    this.institucionSeleccionada.sedes = [];
  }

  public deseleccionarInstitucion(): void {
    this.institucionSeleccionada = new InstitucionSnp();
    this.sedeSeleccionada = {};
  }

  public mostrarModal(): void {
    this.deseleccionarInstitucion();
    this.modalVisible = true;
  }

  public agregarInstitucion(): void {
    this.modalVisible = false;
    this.emitirGuardado();
  }

  @Emit('guardado')
  public emitirGuardado(): InstitucionConSedeSeleccion {
    return new InstitucionConSedeSeleccion(
      InstitucionSnp.fromObject(this.institucionSeleccionada),
      SedeSnp.fromObject(this.sedeSeleccionada)
    );
  }
}
